import * as yup from 'yup';
import { InferType } from "yup";



export const CheckIQScoreSchema = yup.object().shape({
    email: yup.string().required('Email is required'),
  });
  export type CheckIQScoreType= InferType<typeof CheckIQScoreSchema>;